import { render, staticRenderFns } from "./InquiriesList.vue?vue&type=template&id=1116b4d4&"
import script from "./InquiriesList.vue?vue&type=script&lang=js&"
export * from "./InquiriesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports